import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ProgramUsers from '../../../../../pages/new-designs/tabs/Program/components/program tabs/ProgramUsers';
import MatchesMainPage from '../../../../../pages/new-designs/tabs/Matches/MatchesMainPage';
import { useProgramCreation } from '../../ProgramCreationContext';
import { API } from '../../../../../api';
import { getUserDetails } from '../../../../../utils/orgName';
import { useAppDispatch } from '../../../../../redux/hooks';
import { fetchAllGroups } from '../../../../../redux/slices/getAllGroups/getAllGroupsSlice';
import { fetchUserGroupList } from '../../../../../redux/slices/groupRolesListSlice';
import { fetchGroupDetails, grpDetailsActions } from '../../../../../redux/slices/group-details/groupDetails';
import StepNavigator from '../components/StepNavigator';
import DosenButton from '../../../../ui/Buttons/DosenButton';

export const StepAI_Members = () => {
  const navigate = useNavigate();
  const { state } = useProgramCreation();
  const userDetails = getUserDetails();
  const { location } = userDetails;
  const { id: grpId = '', coId: coIdParam = '', orgId: orgIdParam = '' } = useParams();
  const reduxDispatch = useAppDispatch();
  const fallbackOrgId = orgIdParam || userDetails.orgId || '';
  const isAIFlow = state.buildMode === 'ai';
  const missingGroup = !state.groupId;
  const missingGeneration = isAIFlow && !state.generationId;
  const programType = state.programType;
  const isMentorshipProgram = programType === 'mentorship';
  const targetGroupId = state.groupId;

  console.log({state})

  const [memberView, setMemberView] = useState<'members' | 'matches'>('members');
  const [publishing, setPublishing] = useState(false);

  useEffect(() => {
    if (missingGroup || missingGeneration) {
      navigate(isAIFlow ? '../review' : '../', { replace: true });
    }
  }, [missingGroup, missingGeneration, navigate, isAIFlow]);

  const handlePublish = async () => {
    if (!targetGroupId || !coIdParam) {
      toast.error('Missing workspace information. Please return to Review.');
      return;
    }
    setPublishing(true);
    try {
      if (isMentorshipProgram) {
        toast.success('Mentorship published successfully');
      } else {
        const publishRes = await API.publishTask({ location, grpId: targetGroupId, orgId: orgIdParam });
        if (publishRes?.status === 200) {
          await API.updateGroupSettings({ groupId: targetGroupId, location });
          await reduxDispatch(
            fetchGroupDetails({
              grpId: targetGroupId,
              loc: location,
              useCache: false
            })
          );
          reduxDispatch(grpDetailsActions.updatePublishKey(true));
          toast.success('Program published successfully');
        } else {
          throw new Error('Failed to publish program');
        }
      }
      if (fallbackOrgId && targetGroupId) {
        await reduxDispatch(fetchUserGroupList());
        reduxDispatch(fetchAllGroups({ orgId: fallbackOrgId, grpId: targetGroupId, useCache: false }));
      }
      navigate(
        `/app/programdetails/${orgIdParam || 'org'}/${coIdParam}/admin/overview`,
        { replace: true }
      );
    } catch (err) {
      console.error(err);
      toast.error('Failed to publish program');
    } finally {
      setPublishing(false);
    }
  };

  const navigatorSteps = isAIFlow ? undefined : ['Review', 'Members'];

  return (
    <Box display="flex" flexDirection="column" height="100%" bgcolor="#0F0F0F">
      <Box sx={{ mb: 2 }}>
        <StepNavigator currentStep="Members" steps={navigatorSteps} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          py: 2,
          borderBottom: '1px solid #2A2A2A'
        }}
      >
        <Typography color="#FDFDFD" fontSize={20} fontWeight={700}>
          Members
        </Typography>
        <Box
          sx={{
            display: 'inline-flex',
            borderRadius: 1,
            overflow: 'hidden',
            border: '1px solid #2A2A2A'
          }}
        >
          {['members', 'matches'].map((mode) => {
            const isSel = memberView === mode;
            return (
              <Box
                key={mode}
                role="button"
                // onClick={() => setMemberView(mode as 'members' | 'matches')}
                sx={{
                  px: 2.25,
                  py: 1.1,
                  bgcolor: isSel ? '#444444' : '#2A2A2A',
                  color: isSel ? '#FDFDFD' : '#B6B6B6',
                  fontSize: 12,
                  fontWeight: isSel ? 700 : 400,
                  fontFamily: 'Inter, sans-serif'
                }}
              >
                {mode === 'members' ? 'Members List' : 'Matches'}
              </Box>
            );
          })}
        </Box>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', background: '#0F0F0F' }}>
        {memberView === 'members' ? (
          <ProgramUsers />
        ) : (
          <Box sx={{ height: '100%', overflow: 'auto' }}>
            <MatchesMainPage />
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          px: 3,
          py: 2,
          borderTop: '1px solid #2A2A2A',
          gap: 2
        }}
      >
        <DosenButton
          // variant="contained"
          onClick={handlePublish}
          disabled={publishing}
          // sx={{ bgcolor: '#F79420', color: '#000', minWidth: 160 }}
        >
          {publishing ? 'Saving...' : 'Save and Finish'}
        </DosenButton>
      </Box>
    </Box>
  );
};

export default StepAI_Members;
